import {
    Grid as DivGrid, FormLabel, FormHelperText,
    CircularProgress, Typography, Link as Hyperlink, Paper, Button
} from '@material-ui/core';
// import {  Button } from "antd";
import "./styles.css";
import { VerticalAlignTopOutlined, DownloadOutlined } from '@ant-design/icons';
import useStyles from "./styles";

import SaveIcon from '@material-ui/icons/Save';
import ArrowBackIosIcon from '@material-ui/icons/ArrowBackIos';
import ArrowForwardIosIcon from '@material-ui/icons/ArrowForwardIos';
import DescriptionIcon from '@material-ui/icons/Description';
import SearchIcon from '@material-ui/icons/Search';
import ReplayIcon from '@material-ui/icons/Replay';
import ResetIcon from '../../images/icons/reset-icon.png'
import DeleteIcon from '../../images/icons/deleteBtnIcon.png';
import PrintIcon from '../../images/icons/print.svg';
import Close from '@material-ui/icons/Close';
import Draggable from 'react-draggable';

function Label({ size, title, mandatory, isTextAreaInput, isDisabled, ...props }) {

    return (
        <DivGrid item xs={12} sm={size} md={size} lg={size} container direction="row" className='label-align'>
            <FormLabel disabled={isDisabled} className={isTextAreaInput ? 'text-area-input' : 'lable-Input'} {...props}>
                {title}
                {mandatory ?
                    <span className='mandator-color'>*</span> : null
                }:
            </FormLabel>
        </DivGrid>
    )
}



function CustomBtn({ id, btnType, htmlType, onClick, size, loading, shape, children, isDisabled, ...props }) {
    return (
        <>
            {id == "delete" ?
                <Button type={btnType} htmlType={htmlType} size={size} loading={loading} id={id} className="custom-btn custom-delete-button" disabled={isDisabled} onClick={onClick} {...props}>{children}</Button>
                : ''
            }
            {id == "save" ?
                <Button type={btnType} htmlType={htmlType} size={size} loading={loading} id={id} className="primary-navy-blue" disabled={isDisabled} onClick={onClick} {...props}>{children}</Button>
                : ''
            }
            {id == "reset" ?
                <Button type={btnType} htmlType={htmlType} size={size} loading={loading} id={id} className="custom-btn custom-reset-button" disabled={isDisabled} onClick={onClick} {...props}>{children}</Button>
                : ''
            }
            {id == "update" ?
                <Button type={btnType} htmlType={htmlType} shape={shape} size={size} loading={loading} id={id} className="custom-btn custom-update-button" disabled={isDisabled} onClick={onClick} {...props}>{children}</Button>
                : ''
            }

            {id == "export" ?
                <Button type={btnType} icon={<VerticalAlignTopOutlined />} htmlType={htmlType} shape={shape} size={size} loading={loading} id={id} className="primary-Button" disabled={isDisabled} onClick={onClick} {...props}>{children}</Button>
                : ''
            }
            {id == "download" ?
                <Button type={btnType} icon={<DownloadOutlined />} htmlType={htmlType} shape={shape} size={size} loading={loading} id={id} className="primary-Button" disabled={isDisabled} onClick={onClick} {...props}>{children}</Button>
                : ''
            }

            {id == "themeBlue" ?
                <Button type={btnType} icon={props.icon} htmlType={htmlType} shape={shape} size={size} loading={loading} id={id} className="primary-ocean-blue" disabled={isDisabled} onClick={onClick} {...props}>{children}</Button>
                : ''
            }
            {id == "themeNavyBlue" ?
                <Button type={btnType} icon={props.icon} htmlType={htmlType} shape={shape} size={size} loading={loading} id={id} className="primary-navy-blue" disabled={isDisabled} onClick={onClick} {...props}>{children}</Button>
                : ''
            }

        </>
    )
}

function FormGroupTitle({ greyBg, children, ...props }) {
    var classes = useStyles();
    return (
        <>
            <Typography variant="subtitle1" className={classes.formTitle} gutterBottom>
                <span className={greyBg ? classes.baseTitleGreyBg : classes.baseTitle}>{children}</span>
                <span className={classes.baseLine}> </span>
            </Typography>
        </>
    )
}

function FormBtn({ id, btnType, onClick, size, children, disabled, ...props }) {
    var classes = useStyles();
    //Class name ( classes.saveBtn, classes.resetBtn, classes.updateBtn, classes.deleteBtn )
    return (
        <>
            {id == "save" ?
                <Button id={id}
                    className={classes.saveBtn}
                    disabled={disabled}
                    onClick={onClick}
                    size={size}
                    startIcon={btnType === "back" ? <ArrowBackIosIcon /> : btnType === "search" ? <SearchIcon /> : btnType === "next" ? null : btnType === "logs" ? <DescriptionIcon /> : btnType === undefined ? <SaveIcon /> : null}
                    endIcon={btnType === "next" ? <ArrowForwardIosIcon /> : null}
                    {...props}>
                    {children}</Button>
                : ''
            }
            {id == "resetBtn" ?
                <Button
                    id={id} className={classes.resetBtn} disabled={disabled} onClick={onClick} size={size}
                    startIcon={<img src={ResetIcon} alt="close" />} {...props}>{children}</Button>
                : ''
            }

            {id == "download" ?
                <Button
                    id={id} className={classes.downloadBtn} disabled={disabled} onClick={onClick} size={size}
                    startIcon={<DownloadOutlined />} {...props}>{children}</Button>
                : ''
            }

            {id == "reset" ?
                <Button
                    id={id} className={classes.resetBtn} disabled={disabled} onClick={onClick} size={size} {...props}>{children}</Button>
                : ''
            }
            {id == "close" ?
                <Button id={id} className={classes.resetBtn} disabled={disabled} onClick={onClick} size={size} startIcon={<Close />}
                    {...props}>{children}</Button>
                : ''
            }
            {id == "lightBlue" ?
                <Button id={id} className={classes.lightBlueBtn} disabled={disabled} onClick={onClick} size={size} {...props}>{children}</Button>
                : ''
            }
            {id == "update" ?
                <Button id={id} className={classes.updateBtn} disabled={disabled} onClick={onClick} size={size}

                    {...props}>{children}</Button>
                : ''
            }
            {id == "delete" ?
                <Button id={id} className={classes.deleteBtn} disabled={disabled} onClick={onClick} size={size}
                    startIcon={<img src={DeleteIcon} alt="deleteIcon" />}
                    {...props}>{children}</Button>
                : ''
            }

            {id == "senderx" ?
                <Button id={id} className={classes.erxBtn} disabled={disabled} onClick={onClick} size={size}
                    {...props}>{children}</Button>
                : ''
            }

            {id == "loadSenderx" ?
                <Button id={id} className={classes.erxBtn} disabled={disabled} onClick={onClick} size={size}
                    {...props}>
                    <CircularProgress className={classes.circularProgressBar} size={20} />
                    {children}
                </Button>
                : ''
            }

            {id == "print" ?
                <Button id={id} className={classes.printBtn} disabled={disabled} onClick={onClick} size={size}
                    startIcon={<img src={PrintIcon} alt="printIcon" />}
                    {...props}>{children}</Button> : ''}

            {id == "loadingPrint" ?
                <Button id={id} className={classes.printBtn} disabled={disabled} onClick={onClick} size={size}
                    {...props}>
                    <CircularProgress className={classes.circularProgressBar} size={20} />
                    {children}
                </Button> : ''}

            {id == "noIcon" ?
                <Button id={id}
                    className={classes.saveBtn}
                    disabled={disabled}
                    onClick={onClick}
                    size={size}
                    {...props}>
                    {children}</Button>
                : ''
            }
            {id == "loadingSave" ?
                <Button id={id} className={classes.saveBtn} size={size} onClick={onClick} disabled={disabled} {...props}>
                    <CircularProgress className={classes.circularProgressBar} size={20} />
                    {children}
                </Button>
                : ''
            }
            {id == "loadingDelete" ?
                <Button id={id} className={classes.deleteBtn} size={size} onClick={onClick} disabled={disabled} {...props}>
                    <CircularProgress className={classes.circularProgressBar} size={20} />
                    {children}
                </Button>
                : ''
            }
        </>
    )
}

function LinkS({ onClick, href, children, target, ...props }) {
    var classes = useStyles();


    return (
        <>
            <Hyperlink className={classes.hyperlink} href={href} target={target} onClick={onClick} {...props}>
                {children}
            </Hyperlink>
        </>
    );
}

function ErrorMessage({ children, textArea, ...props }) {
    var classes = useStyles();
    return (
        <>
            <FormHelperText className={textArea === true ? classes.errorMessageTextArea : classes.errorMessage}>
                <span>{children}</span>
            </FormHelperText>
        </>
    )
}

function DraggableComponent(props) {
    return (
        <Draggable
            handle="#draggable-dialog-title"
            cancel={'[class*="MuiDialogContent-root"]'}
        >
            <Paper {...props} />
        </Draggable>
    );
}



// function CustomBtn({ id, btnType, htmlType, onClick, size, loading, shape, children, isDisabled, ...props }) {
//     return (
//         <>
//             {id == "save" ?
//                 <Button type={btnType} htmlType={htmlType} shape={shape} size={size} loading={loading} id={id} className="custom-button" disabled={isDisabled} onClick={onClick} {...props}>{children}</Button>
//                 : ''
//             }
//         </>
//     )
// }

export { Label, CustomBtn, FormGroupTitle, FormBtn, LinkS, ErrorMessage, DraggableComponent };